import styled from 'styled-components';

const StyledMedicalConsentAndAuthorizationPrintModal = styled.div`
   min-width: 400px;
`;

StyledMedicalConsentAndAuthorizationPrintModal.displayName = 'StyledMedicalConsentAndAuthorizationPrintModal';

export { StyledMedicalConsentAndAuthorizationPrintModal };
